import styles from './CourseGrid.module.css'
import type {Course} from "../../../types/course/Course.tsx";
import CourseCard from "../course-card/CourseCard.tsx";

type CourseGridProps = {
    courses: Array<Course>
}

function CourseGrid(props : CourseGridProps) {
    return (
        <div className={ `${ styles.courseGrid } row g-4 mb-5` }>
            {props.courses.map((course : Course) => (
                <div className="col-md-6 col-lg-4" key={course.title}>
                    <CourseCard key={course.id} course={course} />
                </div>
            ))}
        </div>
    );
}

export default CourseGrid;